import React, { Component } from 'react';

let MobileTogglebutton = props => (

    <div className="mobile-nav-button">
        <button type="button" className="icon" aria-label="Open navigation menu" onClick={props.hamburgerClickHandler}>
            <i className="fa fa-bars" aria-hidden="true"></i>
        </button>
    </div>

);

export default MobileTogglebutton;